import "./App.css";
import HomePage from "./components/homePage";
function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
